import {
    ISubscriptionInfo,
    ISubscriptionPreferencesState,
    ISubscriptionsEditableData,
    subscriptionPreferencesAT,
    TSubscriptionPreferencesMode,
    TSubscriptionPreferencesScreens,
} from "./SubscriptionPreferencesModel";
import moment from "moment";
import { combineReducers } from "redux";
import { IUmSpAuthState } from "../_features/auth/AuthModel";
import { IObjectScheme } from "../../../../common/model/api/Datasources/IDataSourceScheme";
import { generalConsentsReducer } from "../generalConsents/generalConsentsReducer";
import { subscriptionsReducer } from "../subscriptionsTable/subscriptionsReducer";
import { loadDynamicContentReducer } from "../_features/loadDynamicContent/loadDynamicContentReducer";

export const subscriptionPreferencesReducer = combineReducers<ISubscriptionPreferencesState>(
    {
        screen,
        mode,
        resendTimeStamp,
        error,
        auth,
        scheme,
        data: combineReducers({
            generalConsents: generalConsentsReducer,
            subscriptionsTypes,
            subscriptions: subscriptionsReducer,
        }),
        oldData,
        updateErrors,
        dynamicContent: loadDynamicContentReducer,
    }
);

function screen(
    state: TSubscriptionPreferencesScreens = null,
    action
): TSubscriptionPreferencesScreens {
    switch (action.type) {
        case subscriptionPreferencesAT.error:
            return action.fatal ? "error" : state;

        case subscriptionPreferencesAT.hasUser:
        case subscriptionPreferencesAT.hasntUser:
            return "forms";

        default:
            return state;
    }
}

function mode(
    state: TSubscriptionPreferencesMode = null,
    action
): TSubscriptionPreferencesMode {
    switch (action.type) {
        case subscriptionPreferencesAT.hasUser:
        case subscriptionPreferencesAT.hasErrorsOnSaveData:
            return "edit";

        case subscriptionPreferencesAT.saveData:
            return "saving";

        case subscriptionPreferencesAT.hasConsents:
            return state == "saving" ? "saved" : "edit";

        case subscriptionPreferencesAT.consentChange:
        case subscriptionPreferencesAT.subscriptionChange:
            return state == "saved" ? "edit" : state;

        default:
            return state;
    }
}

function resendTimeStamp(state: number = null, action): number {
    return state;
}

function error(state: string = null, action): string {
    switch (action.type) {
        case subscriptionPreferencesAT.error:
            return action.error;

        default:
            return state;
    }
}

function auth(state: IUmSpAuthState = null, action): IUmSpAuthState {
    return action.type == subscriptionPreferencesAT.hasUser
        ? action.authInfo
        : state;
}

function scheme(state: IObjectScheme = null, action): IObjectScheme {
    switch (action.type) {
        case subscriptionPreferencesAT.hasScheme:
            return action.scheme;

        default:
            return state;
    }
}

function oldData(
    state: ISubscriptionsEditableData = null,
    action
): ISubscriptionsEditableData {
    switch (action.type) {
        case subscriptionPreferencesAT.hasConsents:
            return {
                generalConsents: action.consents,
                subscriptions: action.userSubscriptionsObject,
            };

        default:
            return state;
    }
}

function subscriptionsTypes(
    state: ISubscriptionInfo[] = [],
    action
): ISubscriptionInfo[] {
    switch (action.type) {
        case subscriptionPreferencesAT.hasConsents:
            return action.subscriptions;

        default:
            return state;
    }
}

function updateErrors(state = null, action) {
    switch (action.type) {
        case subscriptionPreferencesAT.hasErrorsOnSaveData:
            return action.errors;

        case subscriptionPreferencesAT.revertData:
            return null;

        case subscriptionPreferencesAT.subscriptionChange:
            const subscriptionKey = "subscription_" + action.consentId;
            if (!state || !state[subscriptionKey]) return state;
            const newState = { ...state };
            delete newState[subscriptionKey];
            return newState;

        case subscriptionPreferencesAT.consentChange:
            if (!state || !state["consent"]) return state;
            const noConsentState = { ...state };
            delete noConsentState["consent"];
            return noConsentState;

        default:
            return state;
    }
}

//todo: use later when there will be login by sms/email api
export function subscriptionPreferencesReducer2(
    state: ISubscriptionPreferencesState = null,
    action
): ISubscriptionPreferencesState {
    switch (action.type) {
        case subscriptionPreferencesAT.identify:
            const now = moment();
            now.add(40, "seconds");

            return {
                ...state,
                mode: "confirm",
                resendTimeStamp: now.toDate().valueOf(),
            };

        case subscriptionPreferencesAT.reenter:
            return { ...state, mode: "identify" };

        case subscriptionPreferencesAT.submitCode:
            return { ...state, mode: "edit" };

        case subscriptionPreferencesAT.error:
            return { ...state, mode: "error", error: action.error };

        default:
            return state;
    }
}
